import React from "react";

interface CustomBannerProps {
  logoUrl?: string;
  NMLSID?: string;
  customBannerText?: string;
  phoneNumberForOrganicFlow?: string;
}

const CustomBanner: React.FC<CustomBannerProps> = ({
  logoUrl,
  NMLSID,
  customBannerText,
  phoneNumberForOrganicFlow,
}) => (
  <div
    style={{
      maxWidth: "900px",
      margin: "48px auto 32px auto",
      padding: "0 16px",
    }}
  >
    <div
      className="custom-banner-flex"
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "stretch",
        gap: "32px",
        minHeight: 180,
      }}
    >
      <div
        style={{
          flex: 1,
          minWidth: 120,
          maxWidth: 180,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 180,
            width: "100%",
          }}
        >
          <img
            src={logoUrl}
            alt="PowerPay Logo"
            style={{
              width: 160,
              height: 160,
              objectFit: "contain",
              borderRadius: 16,
              display: "block",
            }}
          />
        </div>
        <div
          style={{
            fontSize: 16,
            color: "#222",
            fontWeight: 400,
            textAlign: "center",
            marginTop: 8,
          }}
        >
          <b>NMLS ID #</b>
          <span style={{ fontWeight: 400 }}>{NMLSID}</span>
        </div>
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 180,
            width: "100%",
          }}
        >
          <p
            style={{
              fontSize: 18,
              color: "#222",
              marginBottom: 10,
              lineHeight: 1.6,
              maxWidth: 515,
              fontWeight: 400,
              textAlign: "center",
            }}
            dangerouslySetInnerHTML={{ __html: customBannerText || "" }}
          />
        </div>
        <div
          style={{
            fontSize: 16,
            color: "#222",
            fontWeight: 400,
            textAlign: "center",
            marginTop: 8,
          }}
        >
          Questions? {phoneNumberForOrganicFlow}
        </div>
      </div>
    </div>
    <style>
      {`
                @media (max-width: 600px) {
                    .custom-banner-flex {
                        flex-direction: column !important;
                        gap: 16px !important;
                        align-items: center !important;
                    }
                }
            `}
    </style>
  </div>
);

export default CustomBanner;
